import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService } from '@core/services/auth.service';
import { RcService } from '@core/services/rc.service';
import { NavigationService } from '@core/services/navigation.service';
import { MaterialModule } from '@app/material.module';
import { SharedModule } from '@shared/shared.module';
import * as UserActions from '@app/store/actions/user.actions';

@Component({
  selector: 'app-redirect-page',
  imports: [CommonModule, RouterModule, SharedModule, MaterialModule],
  templateUrl: './redirect-page.component.html',
  styleUrl: './redirect-page.component.css'
})
export class RedirectPageComponent implements OnInit {

  constructor(
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly store: Store,
    private readonly rcService: RcService,
    private readonly navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    // Get EmployeeNumber and UserToken from the URL query parameters
    this.route.queryParams.subscribe((params) => {
      const employeeNumber = params['EmployeeNumber'];
      const clientToken = params['ClientToken'];
      const userToken = params['UserToken'];

      if (!employeeNumber || !clientToken || !userToken) {
        // Redirect to login if required parameters are missing
        this.navigationService.navigateToLogin(this.rcService.getTenant());
        return;
      }

      // Call the API to validate the user
      this.authService.validateRedirectUser(employeeNumber, clientToken, userToken).subscribe({
        next: (response) => {
          if (response.IsInventory) {
            // Prepare login data
            const loginData = {
              ...response,
              token: response.LoginToken,
              credentials: {
                EmployeeNumber: employeeNumber
              }
            };

            // Set authentication data
            this.store.dispatch(UserActions.login({ user: loginData }));
            this.authService.setToken(userToken);
            this.authService.setCurrentUser(loginData);

            // Use navigation service for consistent redirect handling
            // Reduced timeout for better performance
            setTimeout(() => {
              this.navigationService.safeNavigate([`/${this.rcService.getTenant()}/inventory/master`]);
            }, 1000); // Reduced from 3000ms to 1000ms
          } else {
            // Redirect to the login page if not inventory user
            this.navigationService.navigateToLogin(this.rcService.getTenant());
          }
        },
        error: (error) => {
          console.error('Validation error:', error);
          // Handle error, redirect to login
          this.navigationService.navigateToLogin(this.rcService.getTenant());
        }
      });
    });
  }

}
